import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import createHistory from 'history/createBrowserHistory';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
// import { persistStore, persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
import reducers from './reducers';
import rootSaga from './sagas';

const history = createHistory();
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);
const middlewares = [thunk, sagaMiddleware, routeMiddleware];

// const persistConfig = {
//   key: 'root',
//   storage: storage,
//   blacklist: ['Register']
//  };

// const store = createStore(
//   persistReducer(persistConfig, combineReducers({
//     ...reducers,
//     router: routerReducer
//   })),
//   compose(applyMiddleware(...middlewares))
// );

const store = createStore(
  combineReducers({
    ...reducers,
    router: routerReducer
  }),
  compose(applyMiddleware(...middlewares))
);

// const persistor = persistStore(store);
// store.subscribe(() => console.log('store',store.getState()));
sagaMiddleware.run(rootSaga);
// export { store, persistor, history };
export { store, history };



// WEBPACK FOOTER //
// ./src/redux/store.js